<template>
  <tr class="item-row invoice-item-row">
    <td colspan="8">
      <table class="full-width">
        <colgroup>
          <col style="width: 2%;">
          <col style="width: 20%;">
          <col style="width: 20%;">
          <col style="width: 10%;">
          <col style="width: 15%;">
          <col v-if="discountPerItem === 'YES'" style="width: 15%;">
          <col style="width: 15%;">
        </colgroup>
        <tbody>
          <tr>
            <td>
              <div class="sort-icon-wrapper handle">
                <font-awesome-icon
                  class="sort-icon"
                  icon="grip-vertical"
                />
              </div>
            </td>
            <td class="">
              <div class="item-select-wrapper">
                <item-select-through-name
                  ref="itemSelect"
                  :invalid="$v.item.name.$error"
                  :invalid-description="$v.item.description.$error"
                  :item="item"
                  @search="searchVal"
                  @select="onSelectItem"
                  @deselect="deselectItem"
                  @onDesriptionInput="$v.item.description.$touch()"
                  @onSelectItem="isSelected = true"
                />
              </div>
            </td>
            <td class="">
              <div class="item-select-wrapper">
                <item-select-through-part-number
                  ref="itemSelect"
                  :invalid="$v.item.name.$error"
                  :invalid-description="$v.item.description.$error"
                  :item="item"
                  @search="searchVal"
                  @select="onSelectItem"
                  @deselect="deselectItem"
                  @onDesriptionInput="$v.item.description.$touch()"
                  @onSelectItem="isSelected = true"
                />
              </div>
            </td>
            <td class="text-left">
              <base-input
                v-model="item.quantity"
                :invalid="$v.item.quantity.$error"
                type="text"
                small
                @keyup="updateItem"
                @input="$v.item.quantity.$touch()"
              />
              <div v-if="$v.item.quantity.$error">
                <span v-if="!$v.item.quantity.maxLength" class="text-danger">{{ $t('validation.quantity_maxlength') }}</span>
              </div>
            </td>
            <td class="text-left">
              <div class="d-flex flex-column">
                <div class="flex-fillbd-highlight">
                  <div class="base-input">
                    <money
                      v-model="price"
                      v-bind="customerCurrency"
                      class="input-field"
                      disabled
                      @input="$v.item.price.$touch()"
                    />
                  </div>
                  <div v-if="$v.item.price.$error">
                    <span v-if="!$v.item.price.maxLength" class="text-danger">{{ $t('validation.price_maxlength') }}</span>
                  </div>
                </div>

              </div>
            </td>
            <td v-if="discountPerItem === 'YES'" class="">
              <div class="d-flex flex-column bd-highlight">
                <div
                  class="btn-group flex-fill bd-highlight"
                  role="group"
                >
                  <base-input
                    v-model="discount"
                    :invalid="$v.item.discount_val.$error"
                    input-class="item-discount"
                    @input="$v.item.discount_val.$touch()"
                  />
                  <v-dropdown :show-arrow="false" theme-light>
                    <button
                      slot="activator"
                      type="button"
                      class="btn item-dropdown dropdown-toggle"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      {{ item.discount_type == 'fixed' ? currency.symbol : '%' }}
                    </button>
                    <v-dropdown-item>
                      <a class="dropdown-item" href="#" @click.prevent="selectFixed" >
                        {{ $t('general.fixed') }}
                      </a>
                    </v-dropdown-item>
                    <v-dropdown-item>
                      <a class="dropdown-item" href="#" @click.prevent="selectPercentage">
                        {{ $t('general.percentage') }}
                      </a>
                    </v-dropdown-item>
                  </v-dropdown>
                </div>
                <div v-if="$v.item.discount_val.$error" class="text-danger">
                  <span v-if="item.discount_type === 'percentage' && !(item.discount >= 0 && item.discount <= 100)">
                    Discount percentage must be between 0 and 100.
                  </span>
                  <span v-else>
                    Discount value must be between 0 and the item price.
                  </span>
                </div>
              </div>
            </td>
            <td class="text-right">
              <div class="item-amount">
                <span>
                  <div v-html="$utils.formatMoney(total, currency)" />
                </span>

                <div class="remove-icon-wrapper">
                  <font-awesome-icon
                    v-if="showRemoveItemIcon"
                    class="remove-icon"
                    icon="trash-alt"
                    @click="removeItem"
                  />
                </div>
              </div>
            </td>
          </tr>
          <tr v-if="taxPerItem === 'YES'" class="tax-tr">
            <td />
            <td colspan="4">
              <tax
                v-for="(tax, index) in item.taxes"
                :key="tax.id"
                :index="index"
                :tax-data="tax"
                :taxes="item.taxes"
                :discounted-total="total"
                :total-tax="totalSimpleTax"
                :total="total"
                :currency="currency"
                @update="updateTax"
                @remove="removeTax"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </td>
  </tr>
</template>
<script>
import Guid from 'guid'
import { validationMixin } from 'vuelidate'
import { mapGetters } from 'vuex'
import TaxStub from '../../../stub/tax'
import OfferToSellStub from '../../../stub/offerToSell'
import Tax from './Tax'
import ItemSelectThroughName from './ItemSelectThroughName.vue'
import ItemSelectThroughPartNumber from './ItemSelectThroughPartNumber.vue'
const { required, minValue, maxLength } = require('vuelidate/lib/validators')

export default {
  components: {
    Tax,
    ItemSelectThroughName,
    ItemSelectThroughPartNumber
  },
  mixins: [validationMixin],
  props: {
    itemData: {
      type: Object,
      default: null
    },
    index: {
      type: Number,
      default: null
    },
    type: {
      type: String,
      default: ''
    },
    currency: {
      type: [Object, String],
      required: true
    },
    taxPerItem: {
      type: String,
      default: ''
    },
    discountPerItem: {
      type: String,
      default: ''
    },
    invoiceItems: {
      type: Array,
      default: null
    }
  },
  data () {
    return {
      isClosePopup: false,
      itemSelect: null,
      item: {...this.itemData},
      maxDiscount: 0,
      originalPrice: 0,
      money: {
        decimal: '.',
        thousands: ',',
        prefix: '$ ',
        precision: 2,
        masked: false
      },
      isSelected: false
    }
  },
  computed: {
    ...mapGetters('item', [
      'items'
    ]),
    ...mapGetters('modal', [
      'modalActive'
    ]),
    ...mapGetters('currency', [
      'defaultCurrencyForInput'
    ]),
    ...mapGetters('invoice', [
    ]),
    customerCurrency () {
      if (this.currency) {
        return {
          decimal: this.currency.decimal_separator,
          thousands: this.currency.thousand_separator,
          prefix: this.currency.symbol + ' ',
          precision: this.currency.precision,
          masked: false
        }
      } else {
        return this.defaultCurrenctForInput
      }
    },
    showRemoveItemIcon () {
      if (this.invoiceItems.length === 1) {
        return false
      }
      return true
    },
    subtotal () {
      return this.item.price * this.item.quantity
    },
    discount: {
      get: function () {
        return this.item.discount
      },
      set: function (newValue) {
        // Parse the new value
        const discountValue = Number(newValue) || 0

        // Calculate discount_val based on type
        if (this.item.discount_type === 'percentage') {
          this.item.discount_val = (this.subtotal * newValue) / 100
        } else {
          this.item.discount_val = newValue
        }

        // Set the discount value
        this.item.discount = discountValue

        // Force reactivity update
        this.$nextTick(() => {
          this.updateItem()
        })
      }
    },
    discountedUnitPrice () {
      const basePrice = Number(this.originalPrice) || 0
      const discount = Number(this.item.discount) || 0

      if (discount === 0 || !this.isDiscountValid()) {
        return basePrice
      }
      let discounted
      if (this.item.discount_type === 'percentage') {
        discounted = basePrice - (basePrice * discount / 100)
      } else {
        discounted = basePrice - discount
      }
      // Round to two decimals (half-up)
      return this.$utils.roundToPrecision(Math.max(0, discounted), 2)
    },
    total () {
      const basePrice = Number(this.originalPrice) || 0
      const quantity = Number(this.item.quantity) || 0
      const discount = Number(this.item.discount) || 0
      // Use rounded per-unit price so totals align with displayed unit price
      let unitPrice
      if (discount === 0 || !this.isDiscountValid()) {
        unitPrice = this.$utils.roundToPrecision(basePrice, 2)
      } else if (this.item.discount_type === 'percentage') {
        const discounted = basePrice - (basePrice * discount / 100)
        unitPrice = this.$utils.roundToPrecision(Math.max(0, discounted), 2)
      } else {
        const discounted = basePrice - discount
        unitPrice = this.$utils.roundToPrecision(Math.max(0, discounted), 2)
      }
      const result = unitPrice * quantity
      // Round to currency precision for totals so displayed amount matches expectations
      const precision = this.currency && this.currency.precision != null ? this.currency.precision : 2
      return this.$utils.roundToPrecision(Math.max(0, result), precision)
    },
    totalSimpleTax () {
      return window._.sumBy(this.item.taxes, function (tax) {
        if (!tax.compound_tax) {
          return tax.amount
        }

        return 0
      })
    },
    totalCompoundTax () {
      return window._.sumBy(this.item.taxes, function (tax) {
        if (tax.compound_tax) {
          return tax.amount
        }

        return 0
      })
    },
    totalTax () {
      return this.totalSimpleTax + this.totalCompoundTax
    },
    price: {
      get: function () {
        // Always calculate the current display price based on discount
        const basePrice = Number(this.originalPrice) || 0
        const discount = Number(this.item.discount) || 0

        if (discount === 0) {
          return this.$utils.roundToPrecision(basePrice, 2)
        }

        if (!this.isDiscountValid()) {
          return this.$utils.roundToPrecision(basePrice, 2)
        }
        // Always round
        return this.$utils.roundToPrecision(this.discountedUnitPrice, 2)
      },
      set: function (newValue) {
        const val = parseFloat(newValue)
        if (!isNaN(val)) {
          this.item.price = val
          this.maxDiscount = val
        } else {
          this.item.price = newValue
        }
      }
    },
    formattedMaxDiscount () {
      return this.$utils.formatMoney(this.originalPrice || this.item.price, this.currency)
    },
    formattedMaxDiscountPlain () {
      const amount = this.originalPrice || this.item.price || 0
      const formatted = amount.toFixed(this.currency.precision || 2)
      return `${this.currency.symbol}${formatted}`
    }
  },
  watch: {
    item: {
      handler: 'updateItem',
      deep: true
    },
    subtotal (newValue) {
      if (this.item.discount_type === 'percentage') {
        this.item.discount_val = (this.item.discount * newValue) / 100
      }
    },
    'item.discount': function (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.updateDisplayedPrice()
        this.$nextTick(() => {
          this.updateItem()
        })
      }
    },
    'item.discount_type': function (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.updateDisplayedPrice()
        this.$nextTick(() => {
          this.updateItem()
        })
      }
    },
    modalActive (val) {
      if (!val) {
        this.isSelected = false
      }
    }
  },
  validations () {
    const self = this
    return {
      item: {
        name: {
          required
        },
        quantity: {
          required,
          minValue: minValue(1),
          maxLength: maxLength(20)
        },
        price: {
          required,
          minValue: minValue(1),
          maxLength: maxLength(20)
        },
        discount_val: {
          validDiscount (val) {
            if (self.item.discount_type === 'percentage') {
              return self.item.discount >= 0 && self.item.discount <= 100
            } else {
              return val >= 0 && val <= self.maxDiscount
            }
          }
        },
        description: {
          maxLength: maxLength(255)
        },
        part_number: {
          required
        }
      }
    }
  },
  created () {
    // Only set originalPrice, do NOT set item.price here!
    if (this.itemData.original_price && this.itemData.original_price > 0) {
      this.originalPrice = this.itemData.original_price
    } else if (this.itemData.price && this.itemData.price > 0) {
      this.originalPrice = this.itemData.price
    } else {
      this.originalPrice = 0
    }

    window.hub.$on('checkItems', this.validateItem)
    window.hub.$on('newItem', (val) => {
      if (this.taxPerItem === 'YES') {
        this.item.taxes = val.taxes
      }
      if (!this.item.item_id && this.modalActive && this.isSelected) {
        this.onSelectItem(val)
      }
    })

    // Preserve full price precision - rounding happens at display/save time
    this.item.price = Number(this.originalPrice || this.item.price || 0)
    this.maxDiscount = this.item.price

    // Ensure parent receives the corrected totals immediately
    this.$nextTick(() => {
      this.updateItem()
    })
  },
  methods: {
    updateTax (data) {
      this.$set(this.item.taxes, data.index, data.item)

      let lastTax = this.item.taxes[this.item.taxes.length - 1]

      if (lastTax.tax_type_id !== 0) {
        this.item.taxes.push({...TaxStub, id: Guid.raw()})
      }

      this.updateItem()
    },
    removeTax (index) {
      this.item.taxes.splice(index, 1)

      this.updateItem()
    },
    taxWithPercentage ({ name, percent }) {
      return `${name} (${percent}%)`
    },
    searchVal (val) {
      this.item.name = val
    },
    deselectItem () {
      this.item = {...OfferToSellStub, id: this.item.id, taxes: [{...TaxStub, id: Guid.raw()}]}
      this.originalPrice = 0
      this.maxDiscount = 0
      this.$nextTick(() => {
        this.$refs.itemSelect.$refs.baseSelect.$refs.search.focus()
      })
    },
    onSelectItem (item) {
      this.item.name = item.name
      // Preserve original price precision - don't round prematurely
      this.originalPrice = Number(item.price)
      this.item.price = Number(item.price)
      this.maxDiscount = this.item.price
      this.item.item_id = item.id
      this.item.description = item.description
      this.item.part_number = item.part_number
      this.item.unit_name = item.unit_name
      if (this.taxPerItem === 'YES' && item.taxes) {
        let index = 0
        item.taxes.forEach(tax => {
          this.updateTax({index, item: { ...tax }})
          index++
        })
      }
      // if (this.item.taxes.length) {
      //   this.item.taxes = {...item.taxes}
      // }
    },
    selectFixed () {
      if (this.item.discount_type === 'fixed') {
        return
      }

      this.item.discount_val = this.item.discount * 100
      this.item.discount_type = 'fixed'
    },
    selectPercentage () {
      if (this.item.discount_type === 'percentage') {
        return
      }

      this.item.discount_val = (this.subtotal * this.item.discount) / 100

      this.item.discount_type = 'percentage'
    },
    updateItem () {
      this.$emit('update', {
        'index': this.index,
        'item': {
          ...this.item,
          price: this.price,
          total: this.total,
          totalSimpleTax: this.totalSimpleTax,
          totalCompoundTax: this.totalCompoundTax,
          totalTax: this.totalTax,
          tax: this.totalTax,
          taxes: [...this.item.taxes]
        }
      })
    },
    removeItem () {
      this.$emit('remove', this.index)
    },
    validateItem () {
      this.$v.item.$touch()

      if (this.item !== null) {
        this.$emit('itemValidate', this.index, !this.$v.$invalid)
      } else {
        this.$emit('itemValidate', this.index, false)
      }
    },
    updateDisplayedPrice () {
      // Force reactivity update for price display
      this.$forceUpdate()
      // Also emit an event to parent to ensure totals are recalculated
      this.$nextTick(() => {
        this.updateItem()
      })
    },
    onDiscountInput () {
      // Touch validation
      this.$v.item.discount_val.$touch()

      // If discount becomes empty or 0, ensure we reset properly
      if (this.item.discount === 0 || this.item.discount === '' || this.item.discount === null) {
        this.item.discount = 0
        this.item.discount_val = 0
      }

      // Force immediate update of displayed price and totals
      this.updateDisplayedPrice()
    },
    isDiscountValid () {
      const basePrice = Number(this.originalPrice) || 0
      const discount = Number(this.item.discount) || 0

      if (discount === 0) {
        return true
      }

      if (this.item.discount_type === 'percentage') {
        return this.item.discount >= 0 && this.item.discount <= 100
      } else {
        return discount >= 0 && discount <= basePrice
      }
    }
  }
}
</script>
<style scoped>
  .invoice-create-page .item-table .item-body .item-row td {
    padding-left: 0px !important;
  }
</style>
